import { Dialog } from '@mui/material';
import React, { FC } from 'react';
import BuildingTypeSelectionDialog from '../BuildingTypeSelectionDialog/BuildingTypeSelectionDialog';
import { initialPropsStepEnum, InitProperties } from './init-props';
import styles from './BuildingInitialPropertiesDialog.module.css';
import LivingMixSelection from '../LivingMixSelection/LivingMixSelection';
import { UnitJ } from '../../../../models/section-json';

interface BuildingInitialPropertiesDialogProps {
    open: boolean,
    buildingInitProps: InitProperties,
    unitsJSON: UnitJ[],
    setOpen: (open: boolean) => void,
    setBuildingInitProps: (buildingInitProps: InitProperties) => void
}

const BuildingInitialPropertiesDialog: FC<BuildingInitialPropertiesDialogProps> = ({ open, buildingInitProps, unitsJSON, setOpen, setBuildingInitProps }) => {

    const handleClose = () => {
        setOpen(false);
    };

    return (<div>
        <Dialog fullWidth={true} maxWidth="lg" open={open} onClose={handleClose}>
            {buildingInitProps.stepState === initialPropsStepEnum.buildingType &&
                <BuildingTypeSelectionDialog open={open} setOpen={setOpen} buildingInitProps={buildingInitProps} setBuildingInitProps={setBuildingInitProps} />
            }
            {buildingInitProps.stepState === initialPropsStepEnum.livingMix &&
                <LivingMixSelection unitsJSON={unitsJSON} open={open} setOpen={setOpen} buildingInitProps={buildingInitProps} setBuildingInitProps={setBuildingInitProps} />
            }
        </Dialog>
    </div>
    )
};

export default BuildingInitialPropertiesDialog;
